"use client";
import { jsx as t } from "react/jsx-runtime";
import { focusOutline as m } from "../../common/styles/mixins/focusOutline.js";
import s from "../icon/Icon.js";
import i from "@emotion/styled";
import { COLORS as r } from "../../tokens/colors/Colors.js";
import { ICON_COLORS as d } from "../../tokens/icon-colors/IconColors.js";
import { LINE_HEIGHTS as f } from "../../tokens/line-heights/LineHeights.js";
import { SPACINGS as p } from "../../tokens/spacings/Spacings.js";
const n = ({
  "aria-label": e,
  disabled: a,
  onClick: l,
  type: o,
  ...c
}) => /* @__PURE__ */ t(
  g,
  {
    ...c,
    "aria-label": e ?? o,
    disabled: a,
    type: "button",
    onClick: l,
    children: /* @__PURE__ */ t(u, { feIcon: o === "Next page" ? "chevronRight" : "chevronLeft", feSize: "lg" })
  }
);
n.displayName = "PaginationControl";
const O = n, g = i.button`
	align-items: center;
	border-radius: 2px;
	color: ${d.gray};
	display: inline-flex;
	justify-content: center;
	line-height: ${f.sm};
	margin-left: ${p.xs};
	padding: 2px;

	&:disabled {
		color: ${r.gray500};
		cursor: not-allowed;
	}

	&:focus-visible {
		${m()}
	}

	&:not(:disabled):hover {
		background: ${r.primary200};
	}
`, u = i(s)`
	color: inherit;
`;
export {
  O as default
};
